<template>
  <Modal
    @cancel="onCancel"
    :config="modalConfig"
  >
    <span slot="modalContent">
      <OtpInput
        :otpConfig="otpConfig"
      />
    </span>
  </Modal>
</template>

<script>
import Modal from './Modal.vue'
import OtpInput from './OtpInput.vue'
import event from '@/util/event'

export default {
  name: 'OtpHandler',
  components: {
    Modal,
    OtpInput
  },
  props: {
    otpConfig: {
      type: Object,
      default () {
        return {
          resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
          flex: 'xs12 sm12 md12 lg12 xl12'
        }
      }
    }
  },
  data () {
    return {
      modalConfig: {
        enabled: true,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlineSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('otp-cancelled')
    }
  },
  created () {
    setTimeout(() => {
      event.$emit('SEND_OTP', true)
    }, 200)
    event.$on('IS_OTP_VALID', (isValid) => {
      if (isValid) {
        this.$emit('otp-success')
      }
    })
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
  }
}
</script>
